import React, { useState, useRef } from 'react';
import CakeCard from './CakeCard';
import './FeaturedSection.css';

const FeaturedSection = ({ title, subtitle, cakes, onCakeClick, icon, background, badgeText }) => {
  const [displayLimit, setDisplayLimit] = useState(8);
  const scrollRef = useRef(null);

  if (!cakes || cakes.length === 0) return null;

  const sectionStyle = background ? { background } : {};

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      // Load more when scrolled 50% of the viewable content
      if (scrollLeft + clientWidth >= scrollWidth * 0.5) {
        if (displayLimit < cakes.length) {
          setDisplayLimit(prev => Math.min(prev + 8, cakes.length));
        }
      }
    }
  };

  const visibleCakes = cakes.slice(0, displayLimit);

  return (
    <section className={`featured-section ${background ? 'has-background' : ''}`} style={sectionStyle}>
      <div className="container">
        <div className="featured-header">
          {badgeText && <span className="featured-badge pulse">{badgeText}</span>}
          {icon && <span className="featured-icon">{icon}</span>}
          <h2 className="featured-title">{title}</h2>
          {subtitle && <p className="featured-subtitle">{subtitle}</p>}
        </div>
        
        <div 
          className="featured-scroll-container" 
          ref={scrollRef}
          onScroll={handleScroll}
        >
          <div className="featured-row">
            {visibleCakes.map(cake => (
              <div key={cake.id} className="featured-item">
                <CakeCard 
                  cake={cake} 
                  onAddToCart={onCakeClick}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
